import { ColorService } from "./color.service";
import { LanguageService } from "./language.service";
import {  Injectable } from '@angular/core';

@Injectable()
export class WatchService {
    private lang: LanguageService;

	// Images used in watch
	private checkmarkActivated = document.createElement('img');
    private checkmarkDeactivated = document.createElement('img');
    private colourField = document.createElement('div');
    private imgSize = 25;

    // Used if language gets changed
    private latestTurtle;
    
    constructor(lang: LanguageService) {
        this.lang = lang;
        this.lang.space.subscribe((val) => function(){
            if (val != undefined) {
                this.updateDebugWatch(this.latestTurtle);
            }
            }.bind(this));
        
		this.checkmarkActivated.src = 'app/img/debugIcons/field_activated.png';
        this.checkmarkDeactivated.src = 'app/img/debugIcons/field_deactivated.png';
        
        this.colourField.style.height = (this.imgSize - 4).toString() + 'px';
        this.colourField.style.width = (this.imgSize - 4).toString() + 'px';
        this.colourField.style.borderRadius = '5px';
        this.colourField.style.border = '2px solid #1F1F1F'
    }

	// Sets the values of the turtle state in the debug watch
	public updateDebugWatch(turtle): void {
        this.latestTurtle = turtle;

		// Clear previous debug watch
		let watch = document.getElementById('debugWatchTable');
		while (watch.firstChild) {
			watch.removeChild(watch.firstChild);
		}
	
		// Add new information
		this.addToWatch(watch, this.lang.getLang()['watchPenDown'], turtle.getPenDown());
		this.addToWatch(watch, this.lang.getLang()['watchErasing'], turtle.getErasing());
		this.addToWatch(watch, this.lang.getLang()['watchVisible'], turtle.getVisibility());
		this.addToWatch(watch, this.lang.getLang()['watchColor'], turtle.getPenColor());
		this.addToWatch(watch, this.lang.getLang()['watchWidth'], turtle.getPenWidth().toString());
		this.addToWatch(watch, this.lang.getLang()['watchDirection'], (turtle.getDirection() % 360).toString() + '°');
	}

    // Adds a single element to the debug watch
	private addToWatch(watchTable, entryName, entryValue): void {
        // Set up table
		var tableRow = document.createElement("tr");
		var tableCellName = document.createElement("td");
        var tableCellValue = document.createElement("td");
        tableCellValue.setAttribute('align', 'right');
        
        // Create nodes (name and value)
		var entryNameNode = document.createTextNode(entryName);
		var entryValueNode = this.createValueNode(entryValue);

		tableCellName.appendChild(entryNameNode);
		tableCellValue.appendChild(entryValueNode);
		tableRow.appendChild(tableCellName);
		tableRow.appendChild(tableCellValue);

		watchTable.appendChild(tableRow);
    }

    // Dynamically creates the value presented for a specific attribute
	private createValueNode(entryValue: ColorService | boolean | string): Node {
        let entryValueNode: Node;

        switch(typeof entryValue) {
            case 'boolean':
                let checkmark = document.createElement('img');
                checkmark.style.height = (this.imgSize).toString() + 'px';
                if (entryValue) {
                    checkmark.src = this.checkmarkActivated.src;
                } else {
                    checkmark.src = this.checkmarkDeactivated.src;
                }
                entryValueNode = checkmark;
                break;

            case 'string':
		        entryValueNode = document.createTextNode(<string>entryValue);
                break;

            default:
                this.colourField.style.backgroundColor = (<ColorService>entryValue).getColorString();
                entryValueNode = this.colourField;
                break;
        }

		return entryValueNode;
	}
}


// WEBPACK FOOTER //
// ./src/app/services/watch.service.ts